import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as Moment from "moment";
import * as React from "react";
import { noResultsText } from "../../custom_api/api";
import { moment } from "../../custom_utils/moment";
import { Book } from "./books_block";
import { trackActivitySubscribe } from "./library/tracking";
const activityEditionListStateZero = {};
const sortEditionsByDateAscending = (x, y)=>x.activityEvents.first().date < y.activityEvents.first().date ? -1 : 1;
const ActivityEditionElement = (e)=>{
    return /*#__PURE__*/ _jsxs("li", {
        className: "edition",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "edition__column edition__column--first",
                children: e.activityEvents.sort((a, b)=>a.date < b.date ? -1 : 1).map((e, k)=>{
                    const date = moment(new Date(e.date.getTime() - e.date.getTimezoneOffset() * 60000)).format("dddd D MMMM YYYY");
                    return /*#__PURE__*/ _jsxs("div", {
                        className: "edition__event",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "sr-text",
                                children: "Waar en wanneer: "
                            }),
                            /*#__PURE__*/ _jsx("time", {
                                dateTime: moment(e.date).format('YYYY-MM-DD'),
                                children: date.charAt(0).toUpperCase() + date.slice(1)
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    e.start,
                                    " - ",
                                    e.end
                                ]
                            }),
                            /*#__PURE__*/ _jsx("address", {
                                children: e.location
                            })
                        ]
                    }, `edition-event-${date}`);
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "edition__column edition__column--second",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "edition__info",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "sr-text",
                                children: "Meer informatie: "
                            }),
                            e.signupText && /*#__PURE__*/ _jsx("div", {
                                className: "text--styled",
                                children: e.signupText
                            }),
                            e.signupUrl && /*#__PURE__*/ _jsx("div", {
                                className: "edition__signup edition__signup--mobile",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: e.signupUrl,
                                    target: "_blank",
                                    className: "button button--primary button--arrow",
                                    onClick: ()=>e.activityEvents.map((event)=>trackActivitySubscribe(Moment(event.date).format("DD/MM/YYYY"), event.start, event.end)),
                                    children: "Meld je aan"
                                })
                            }),
                            e.book && /*#__PURE__*/ _jsx("aside", {
                                className: "edition__book",
                                children: /*#__PURE__*/ _jsx(Book, {
                                    title: e.book.title,
                                    author: e.book.author,
                                    imageUrl: '/image' + e.book.image,
                                    imageAlt: `Boekentip ${e.book.title} - ${e.book.author}`,
                                    className: "book--single",
                                    url: e.book.url
                                })
                            })
                        ]
                    }),
                    e.signupUrl && /*#__PURE__*/ _jsx("div", {
                        className: "edition__signup edition__signup--desktop",
                        children: /*#__PURE__*/ _jsx("a", {
                            href: e.signupUrl,
                            target: "_blank",
                            className: "button button--primary button--arrow",
                            onClick: ()=>e.activityEvents.map((event)=>trackActivitySubscribe(Moment(event.date).format("DD/MM/YYYY"), event.start, event.end)),
                            children: "Meld je aan"
                        })
                    })
                ]
            })
        ]
    });
};
export class ActivityEditionList extends React.Component {
    render() {
        const p = this.props;
        const editions = /*#__PURE__*/ _jsxs("section", {
            className: "edition-list",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "edition-list__header title--s",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "sr-text",
                            children: "Overzicht met activiteiten: "
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "edition__column edition__column--first",
                            "aria-hidden": "true",
                            children: "Waar en wanneer"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "edition__column edition__column--second",
                            "aria-hidden": "true",
                            children: "Meer informatie"
                        })
                    ]
                }),
                p.editions.isEmpty() ? /*#__PURE__*/ _jsx("div", {
                    className: "text--styled",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "weight--bold container--s",
                        children: noResultsText
                    })
                }) : /*#__PURE__*/ _jsx("ul", {
                    className: "editions",
                    children: p.editions.sort(sortEditionsByDateAscending).take(20).map((x, i)=>/*#__PURE__*/ _createElement(ActivityEditionElement, {
                            ...x,
                            key: `edition-${i}`
                        })).toArray()
                })
            ]
        });
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: editions
        });
    }
    constructor(props){
        super(props);
        this.state = activityEditionListStateZero;
    }
}
{}